import React from "react";
import Projects from "./Projects";
import Work from "./Work";
import './Info.css';

const Do = () => {
    return (
        <div className="do-container">
            <p>You can just do things</p>
        </div>
    );
};

export default Do;
